import React, { ChangeEventHandler, Dispatch, SetStateAction, useState } from 'react';
import { InputText } from 'components/_new/InputText';
import { EmbedSpecialAttributes } from 'components/_new/NewSlateEditor/types';

export type EmbedEditFormData = Pick<EmbedSpecialAttributes, 'url' | 'alt'>;

const defaultFormData: EmbedEditFormData = { url: '', alt: '' };

export const useEmbedEditForm = (
	initialValue?: EmbedEditFormData
): [[EmbedEditFormData, Dispatch<SetStateAction<EmbedEditFormData>>], () => void] => {
	const [state, setState] = useState<EmbedEditFormData>(initialValue || defaultFormData);
	const reset = () => {
		setState(initialValue || defaultFormData);
	};
	return [[state, setState], reset];
};

type EmbedEditFormProps = {
	formState: [EmbedEditFormData, Dispatch<SetStateAction<EmbedEditFormData>>];
};

export const EmbedEditForm = ({ formState }: EmbedEditFormProps) => {
	const [{ url, alt }, setFormData] = formState;

	const handleUrlChange: ChangeEventHandler<HTMLInputElement> = ({ currentTarget: { value } }) => {
		setFormData((prev) => ({ ...prev, url: value }));
	};

	const handleAltChange: ChangeEventHandler<HTMLInputElement> = ({ currentTarget: { value } }) => {
		setFormData((prev) => ({ ...prev, alt: value }));
	};

	return (
		<div className="flex flex-column gap-2">
			<InputText placeholder="https://...." slim value={url} onChange={handleUrlChange} />
			<InputText placeholder="Tekst alternatywny" slim value={alt || ''} onChange={handleAltChange} />
		</div>
	);
};
